import React, { useState } from "react";
import api from "../services/api";
import Card from "../components/common/Card";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await api.post("auth/forgot-password/", { email });
      setSent(true);
    } catch (err) {
      alert(err.message || "Something went wrong");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 p-4">
      <Card className="w-full max-w-md">
        <h2 className="text-2xl font-bold text-center text-primary-600 mb-4">
          Reset Password
        </h2>

        {sent ? (
          <p className="text-center text-neutral-700">
            If this email exists, a password reset link has been sent.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm mb-1">Enter your email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg"
              />
            </div>

            <button className="w-full bg-primary-600 text-white py-2 rounded-lg">
              Send Reset Link
            </button>
          </form>
        )}
      </Card>
    </div>
  );
};

export default ForgotPassword;
